import React from 'react';
import classNames from 'classnames';
import { FiChevronRight } from 'react-icons/fi';

import { Text, textVariantsEnum, fontWeightEnum } from '@components/Text';
import { IconBadge, iconBadgeSizes } from '@components/IconBadge';

import styles from './SettingsNavItem.module.scss';

export const SettingsNavItem = ({
  icon: Icon,
  title,
  subtitle,
  active,
  onClick,
}) => (
  <button
    type="button"
    className={classNames(styles.navItem, { [styles.navItem_active]: active })}
    onClick={onClick}
  >
    <IconBadge
      size={iconBadgeSizes.sm}
      bg={active ? 'indigo-100' : 'gray-100'}
      icon={
        <Icon
          size={16}
          color={active ? 'var(--indigo-600)' : 'var(--gray-500)'}
        />
      }
    />
    <div className={styles.textStack}>
      <Text
        variant={textVariantsEnum.Text_sm}
        fontWeight={fontWeightEnum.Semibold}
        color={active ? 'indigo-700' : 'gray-800'}
      >
        {title}
      </Text>
      <Text
        variant={textVariantsEnum.Text_xs}
        fontWeight={fontWeightEnum.Normal}
        color="gray-500"
      >
        {subtitle}
      </Text>
    </div>
    {active && (
      <FiChevronRight
        size={16}
        className={styles.chevron}
        color="var(--indigo-600)"
      />
    )}
  </button>
);

SettingsNavItem.displayName = 'SettingsNavItem';
